import { Spinner } from "@src/shared/components/ui/spinner";

export function WaitingForAccountPanel({ message }: { message: string }) {
  return (
    <div
      aria-busy="true"
      className="flex w-full max-w-[360px] flex-col items-center rounded-[18px] border border-border bg-background px-7 py-8 text-center shadow-[0_18px_50px_rgba(20,23,26,0.10)]"
    >
      <div className="flex size-[68px] items-center justify-center rounded-full bg-primary/10 text-primary">
        <Spinner size="lg" />
      </div>
      <h2 className="mt-5 text-xl font-semibold tracking-[-0.4px] text-foreground">
        Waiting for account creation
      </h2>
      <p
        className="mt-2 max-w-[280px] text-sm leading-[1.55] text-muted-foreground"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {message}
      </p>
      <p className="mt-4 font-mono text-[10.5px] text-muted-foreground">
        This usually finishes in the background before you reach this step.
      </p>
    </div>
  );
}
